import React, {useState, useCallback} from 'react';
import {Field, useFormikContext, formikHelpers} from 'formik';
import cx from 'classnames';
import {PRIVACY, TERMS} from 'constants/url.constants';
import Link from 'ui/controls/Link/Link';
import Button from 'ui/controls/Button/Button';
import { useRecaptcha } from '../../cookies/containers/RecaptchaProvider';
import MessageBubble from './Message/MessageBubble';
import FieldTextarea from './Fields/FieldTextarea';
import FieldText from './Fields/FieldText';
import FormGroup from './Fields/FormGroup';
import 'ui/stylus/base/text.styl';
import './FormContact.styl';

export default function FormContact(props) {
	const {
		handleSubmit,
		isSubmitting,
		isValid,
		isValidating,
		dirty,
	} = props;

	const { setFieldValue, values } = useFormikContext();
	const providerRecaptcha = useRecaptcha();
	const [isLoading, setIsLoading] = useState(false);

	const sendRequest = async () => {
		providerRecaptcha?.resetCaptcha();
		await new Promise((resolve) => setTimeout(resolve, 500));
		const verifiedToken = await providerRecaptcha?.executeRecaptcha();
		if (!verifiedToken) return;
		setFieldValue('g-recaptcha-response', verifiedToken);
		setIsLoading(true);
		setTimeout(() => {
			handleSubmit(values, formikHelpers);
		}, 0);
	};

	const handleChildSubmit = (e) => {
		e.preventDefault();
		sendRequest();
	};

	return (
		<form onSubmit={handleChildSubmit} className="form-contact">
			<MessageBubble
				error={false}
				name={values.name}
			/>
			<div className="form-inner-contact">
				<FormGroup>
					<Field
						type="text"
						name="name"
						component={FieldText}
						label="Your name*"
					/>
				</FormGroup>
				<FormGroup>
					<Field
						type="email"
						name="email"
						component={FieldText}
						label="Your email*"
					/>
				</FormGroup>
				<FormGroup>
					<Field
						type="tel"
						name="phone"
						component={FieldText}
						label="Your phone*"
					/>
				</FormGroup>
				<FormGroup>
					<Field
						type="text"
						name="website"
						component={FieldText}
						label="Product website*"
					/>
				</FormGroup>
				<FormGroup>
					<Field
						type="textarea"
						name="message"
						component={FieldTextarea}
						label="How can we help you?*"
					/>
				</FormGroup>
				<p className="form__footnote">*required fields</p>
				<FormGroup appearance="align-center">
					<Button
						type="submit"
						className={cx({'has-loading': isSubmitting})}
						isDisabled={
							isSubmitting
							|| isValidating
							|| !isValid
							|| !dirty
							|| isLoading
						}
						isSmall
					>
						Send
					</Button>
				</FormGroup>
				<div className="form__text">
					By clicking Send button you agree to and accept our &nbsp;
					<Link className="text-blue" to={TERMS}>Terms of use</Link>
					&nbsp;and&nbsp;
					<Link className="text-blue" to={PRIVACY}>Privacy notice</Link>
				</div>
			</div>
		</form>
	);
}
